import React from 'react';
import { observer } from 'mobx-react';

import { EntityRelatedTabProps } from '../types';

import { BackgroundInformationSections } from '../EntityDetailsTab/styles';

import TasksRelatedToEntities from './components/TasksRelatedToEntities';
import AuditsRelatedToEntities from './components/AuditsRelatedToEntities';
import EntitiesRelatedToEntities from './components/EntitiesRelatedToEntities/EntitiesRelatedToEntities';

const EntityRelatedTab: React.FunctionComponent<EntityRelatedTabProps> = ({ onError, store }) => (
  <BackgroundInformationSections>
    <TasksRelatedToEntities onError={onError} store={store} />
    <AuditsRelatedToEntities onError={onError} store={store} />
    <EntitiesRelatedToEntities onError={onError} store={store} />
  </BackgroundInformationSections>
);

export default observer(EntityRelatedTab);
